<div class="spinner" *ngIf="(loader.isLoading$ | async)">
  <div class="spinner__dot dark"></div>
  <div class="spinner__dot dark"></div>
  <div class="spinner__dot dark"></div>
  <div class="spinner__dot dark"></div>
</div>
